import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import SendIcon from '@mui/icons-material/SendRounded';
import SettingsIcon from '@mui/icons-material/SettingsRounded';
import ManualReportPanel from '../components/reports/ManualReportPanel';
import { ReportSettingsView } from './ReportSettingsView';
import { ReconnectingWebSocket } from '../socket';
import { PillTabs } from '../components/ui/PillTabs';

type ReportTab = 'manual' | 'auto';

interface ReportsViewProps {
  onBack: () => void;
  onSendReport: (introText: string, recipients: string[], groupName?: string, startDate?: Date, endDate?: Date, reportType?: string) => void;
  socket: ReconnectingWebSocket;
}

const ReportsView: React.FC<ReportsViewProps> = ({ onBack, onSendReport, socket }) => {
  const [activeTab, setActiveTab] = useState<ReportTab>('manual');

  return (
    <Box>
      <Box sx={{ mb: { xs: 2, md: 3 } }}>
        <Typography component="h1" sx={{ fontSize: { xs: '1.625rem', md: '2rem' }, fontWeight: 750, letterSpacing: '-0.03em', lineHeight: 1.1 }}>
          Reports
        </Typography>
        <Typography sx={{ mt: 0.5, fontSize: { xs: '0.875rem', md: '0.9375rem' }, color: 'text.secondary' }}>
          Compose, preview and schedule stakeholder reports
        </Typography>
      </Box>

      {/* Sub-navigation */}
      <Box sx={{ mb: { xs: 2, md: 3 } }}>
        <PillTabs<ReportTab>
          value={activeTab}
          onChange={setActiveTab}
          ariaLabel="Report sections"
          items={[
            { value: 'manual', label: 'Manual report', icon: <SendIcon sx={{ fontSize: 16 }} /> },
            { value: 'auto', label: 'Auto configuration', icon: <SettingsIcon sx={{ fontSize: 16 }} /> },
          ]}
        />
      </Box>

      {/* Tab content */}
      {activeTab === 'manual' && (
        <ManualReportPanel onSend={onSendReport} socket={socket} />
      )}

      {activeTab === 'auto' && (
        <ReportSettingsView onBack={onBack} />
      )}
    </Box>
  );
};

export default ReportsView;
